import { useState, useEffect } from "react";
import { useWriteContract, useWaitForTransactionReceipt } from "wagmi";

const useCustomContractWrite = ({ abi, address, functionName, args, value }) => {
 
 const [isLoading, setIsLoading] = useState(false); 
  const [error, setError] = useState(null); 
  const [txHash, setTxHash] = useState(null); 

  const { writeContractAsync } = useWriteContract();

  const executeWrite = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const transaction = await writeContractAsync({
        abi,
        address,
        functionName,
        args,
        value,
      });

      console.log("Transaction initiated:", transaction);
      setTxHash(transaction);
      return transaction;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const { isLoading: isTxLoading, isSuccess: isTxSuccess, isError: isTxError } =
    useWaitForTransactionReceipt({
      hash: txHash,
      enabled: !!txHash, // Only enable polling when txHash exists
    });

  // Log only when txHash exists
  useEffect(() => {
    if (txHash) {
      console.log("Transaction receipt state:", isTxLoading, isTxSuccess, isTxError);
    }
  }, [txHash, isTxLoading, isTxSuccess, isTxError]);

  return {
    executeWrite,
    isLoading: isLoading || isTxLoading,
    isSuccess: isTxSuccess,
    isError: isTxError || !!error,
    error,
    txHash,
  };


};

export default useCustomContractWrite;
